<script setup lang="ts">
const props = defineProps(['message'])
console.log(props.message)
</script>

<template>
    <div>
        <p v-if="props.message.type == 'h2'" class="message title_h2"> {{ message.string }}</p>
        <p v-else-if="message.type == 'h1'" class="message title_h1"> {{ message.string }}</p>
        <p v-else class="message"> {{ message.string }}</p>
    </div>
</template>

<script lang="ts">

export default {
    name: 'MessageString'
}
</script>

<style scoped>

.message {
    font-size: 20px;
    margin-block: 9px;

}
.title_h1 {
    border-right: black solid 4px;
}

.title_h2 {
    border-right: rgb(102, 0, 0) solid 4px;
}
</style>